import "bootstrap/dist/css/bootstrap.min.css";
import { useGetMe } from "customHooks/useGetMe";
import "font-awesome/css/font-awesome.min.css";
import ProtectedRouter from "helper/ProtectedRoute";
import { lazy, Suspense, useState } from "react";
import "react-modern-drawer/dist/index.css";
import "react-phone-number-input/style.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./assets/Styles/style.css";
import "./assets/Styles/table.css";
import { Loader } from "./components/Core/Loader";
import OfflineGuard from "components/OfflineGuard";
import ScrollToTop from "./helper/ScrollToTop";
import { routes } from "./routes";
import DevToolsBlocker from "helper/DevToolsBlocker";
import PwaReminderModal from "modals/PwaReminderModal";
import { isIPadDevice, isInStandaloneMode } from "@/utils";

const NotFound = lazy(() => import("pages/NotFound"));

const REMINDER_SESSION_KEY = "pwa_reminder_dismissed";

function usePwaReminder() {
  const shouldShow =
    isIPadDevice() &&
    !isInStandaloneMode() &&
    !sessionStorage.getItem(REMINDER_SESSION_KEY);

  const [show, setShow] = useState(shouldShow);

  function handleClose(value) {
    if (!value) sessionStorage.setItem(REMINDER_SESSION_KEY, "1");
    setShow(value);
  }

  return [show, handleClose];
}

function App() {
  const userLoading = useGetMe();
  const [showPwaReminder, setShowPwaReminder] = usePwaReminder();

  if (userLoading) {
    return <Loader className="vh-100" />;
  }

  return (
    <OfflineGuard>
      {process.env.NODE_ENV === "production" && <DevToolsBlocker />}
      <PwaReminderModal show={showPwaReminder} setShow={setShowPwaReminder} />
      <ToastContainer />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<Loader className={"vh-100"} />}>
          <Routes>
            {routes.map((route, index) => {
              return (
                <>
                  {Array?.isArray(route?.subMenu) ? (
                    route.subMenu.map((subRoute, subIndex) => {
                      return (
                        <Route
                          key={subIndex}
                          path={subRoute.path}
                          exact={subRoute.exact}
                          element={
                            <ProtectedRouter
                              element={subRoute.element}
                              isProtected={route.protected}
                              permissions={subRoute?.permission}
                            />
                          }
                        />
                      );
                    })
                  ) : (
                    <Route
                      key={index}
                      path={route?.path}
                      exact={route?.exact}
                      element={
                        <ProtectedRouter
                          element={route.element}
                          permissions={route?.permission}
                          isProtected={route.protected}
                        />
                      }
                    />
                  )}
                </>
              );
            })}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </OfflineGuard>
  );
}

export default App;
